import { Steps } from './constants';

const flowConfig = {
  [Steps.PHONE]: {
    getNextSteps: (data, isSkipped) => {
      if (isSkipped) return [];
      return [
        {
          step: Steps.PHONE_VERIFICATION,
          props: createPhoneVerificationStep(data),
        },
      ];
    },
  },
  [Steps.PRICING_PAYWALL]: {
    getNextSteps: (data, isSkipped) => {
      if (isSkipped) return [];
      return [
        {
          step: Steps.CHECKOUT,
          props: createCheckoutStep(),
        },
      ];
    },
  },
};

const stepRelationships = {
  [Steps.PHONE]: {
    dependentSteps: [Steps.PHONE_VERIFICATION],
  },
};

const createPhoneVerificationStep = (phoneData) => ({
  type: Steps.PHONE_VERIFICATION,
  title: 'Enter your verification code',
  subtitle: 'We just sent a 4-digit verification code to the number you provided: ',
  showBackButton: true,
  showSkipButton: false,
  data: phoneData,
});

const createCheckoutStep = () => ({
  type: Steps.CHECKOUT,
  showBackButton: true,
  showSkipButton: false,
});

export const handleSkippedStep = (currentStep, steps) => {
  const dependentSteps = stepRelationships[currentStep]?.dependentSteps || [];
  return steps.filter((step) => !dependentSteps.includes(step));
};

export const getInjectedSteps = (currentStep, stepData, isSkipped) => {
  const flowHandler = flowConfig[currentStep];
  if (!flowHandler) {
    return [];
  }
  return flowHandler.getNextSteps(stepData, isSkipped);
};

export const mergeStepsWithInjected = (steps, currentStep, stepsToInject) => {
  const currentIndex = steps.indexOf(currentStep);
  const baseSteps = steps.slice(0, currentIndex + 1);
  const remainingSteps = steps
    .slice(currentIndex + 1)
    .filter((step) => !stepsToInject.some((inject) => inject.step === step));

  return [...baseSteps, ...stepsToInject.map((s) => s.step), ...remainingSteps];
};

export const createUpdatedStepProps = (stepProps, stepsToInject) => ({
  ...stepProps,
  ...stepsToInject.reduce(
    (acc, { step, props }) => ({
      ...acc,
      [step]: props,
    }),
    {}
  ),
});

export const injectNextSteps = (currentStep, steps, stepProps, stepData, isSkipped) => {
  if (isSkipped) {
    return {
      steps: handleSkippedStep(currentStep, steps),
      stepProps,
    };
  }

  const stepsToInject = getInjectedSteps(currentStep, stepData, isSkipped);
  if (stepsToInject.length === 0) {
    return { steps, stepProps };
  }

  return {
    steps: mergeStepsWithInjected(steps, currentStep, stepsToInject),
    stepProps: createUpdatedStepProps(stepProps, stepsToInject),
  };
};
